module.exports = __webpack_public_path__ + "static/media/team1.71f53420.png";